import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { TimeZoneContextProvider } from '../../contexts/timezone-context';
import { ModalContextProvider } from '../../contexts/modal-context';
import { TenantContextProvider } from '../../contexts/tenant-context';
import { CalendarProvider } from './CalendarContext';
import CalendarPage from './CalendarPage';
const calendarQueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1
        }
    }
});
/**
 * CalendarWrapper — the public entry point for the Calendar feature.
 *
 * Mounts all required context providers and renders the CalendarPage.
 * Props are passed in from the Rails template via data attributes.
 */
function CalendarWrapper({ timeZone, timeZonesForSelect, timeZonesMapping, calendarOptimizationEnabled, calendarDayMaxEvents, calendarNextMonthDays = false, assetsForSelect, visitTypesForSelect, territoriesForSelect, inspectionTypesForSelect, inspectionStatusesForSelect, visitStatusesForSelect, techniciansForSelect, inactiveTechniciansForSelect, permissions }) {
    return (React.createElement(QueryClientProvider, { client: calendarQueryClient },
        React.createElement(TimeZoneContextProvider, { initialTimezone: timeZone, 
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            timeZonesForSelect: timeZonesForSelect, timeZonesMapping: timeZonesMapping },
            React.createElement(TenantContextProvider, null,
                React.createElement(ModalContextProvider, null,
                    React.createElement(CalendarProvider, { assetsForSelect: assetsForSelect, visitTypesForSelect: visitTypesForSelect, territoriesForSelect: territoriesForSelect, inspectionTypesForSelect: inspectionTypesForSelect, inspectionStatusesForSelect: inspectionStatusesForSelect, visitStatusesForSelect: visitStatusesForSelect, techniciansForSelect: techniciansForSelect, inactiveTechniciansForSelect: inactiveTechniciansForSelect, permissions: permissions },
                        React.createElement(CalendarPage, { calendarOptimizationEnabled: calendarOptimizationEnabled, calendarDayMaxEvents: calendarDayMaxEvents, showNextMonthDays: calendarNextMonthDays })))))));
}
export default CalendarWrapper;
